__webpack_require__.p = "https://cdn.plus.yitgroup.com/yitplusprodcontainer/";